import { useEffect, useState } from 'react';

import { blueConicEventNames } from '@shared-types/blueconic.types';
import { Trace, Warn } from '@utilities/logging';

/**
 * Check the presence of the interaction and if it's raised
 * @param variantId
 */
export const useBlueConicInteraction = (variantId: string) => {
  const [interactionRaised, setInteractionRaised] = useState(false);

  useEffect(() => {
    const subscribeToBcEvents = () => {
      Trace('useBlueConicInteraction.subscribeToBcEvents');

      window.blueConicClient.event.subscribe(blueConicEventNames.onEventReady, {}, () => {
        // BlueConic EventReady event was thrown
        const interaction = window.blueConicClient.getInteractionNamesById(variantId);
        Trace('useBlueConicInteraction.onEventReady', interaction);
        if (interaction) setInteractionRaised(true);
      });
    };

    if (window?.blueConicClient?.event?.subscribe) {
      // BlueConic is loaded, subscribe to its events
      subscribeToBcEvents();
    } else {
      // Wait for BlueConic to load
      window.addEventListener('onBlueConicLoaded', subscribeToBcEvents, false);
    }

    return () => {
      window.removeEventListener('onBlueConicLoaded', subscribeToBcEvents);
      try {
        window?.blueConicClient?.event?.unsubscribe(blueConicEventNames.onEventReady);
      } catch (e) {
        Warn(e);
      }
    };
  }, [variantId]);
  return { interactionRaised };
};
